import { Switch } from 'antd';
import React from 'react';
import './liveClock.css';

const LiveClockAction: React.FC<{ enabled: boolean; onChange: (enabled: boolean) => void }> = ({ enabled, onChange }) => (
    <label className="c-extended-menu__item u-flex u-flex-column u-align-items-center u-justify-content-center live-clock-action">
        <Switch size="small" aria-label="Use live clock" checked={enabled} onChange={onChange} />
        <span>Use live clock</span>
    </label>
);

export default LiveClockAction;
